import React from 'react'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()
  
  return (
    <footer className="mt-16 border-t border-border bg-muted/30">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center space-y-2">
          <p className="text-sm text-muted-foreground">
            © {currentYear} QiYue. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground/80">
            备案号：蜀ICP备2022022820号-1
          </p>
          <p className="text-xs text-muted-foreground/60 mt-4">
            由 CodeBuddy 提供技术支持
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
